import * as R from 'ramda';

export const getInitials = R.when(
  R.identity,
  R.pipe(R.split(' '), R.map(R.head), R.join('')),
);
